import React, { Component } from 'react'
import moment from 'moment'
import { Grid, Tab, Table, Input, Button } from 'semantic-ui-react'
import Main from '../../Main';
import { API_GET_CS_DAILY, API_GET_USER_DAILY, API_STATISTIC_ENTRY } from '../../api'

class Dashboard extends Component {
  constructor(props){
    super(props);
    this.state = {
      dataCS: [],
      dataUser: [],
      dateFrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD')
    }
  }

  setUserDaily(){
    let paramDate = {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo
    }
    API_GET_USER_DAILY(paramDate)
      .then((response) => {
        this.setState({ dataUser: response.data.data })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  componentDidMount(){
    API_GET_CS_DAILY()
      .then((response) => {
        this.setState({ dataCS: response.data.data })
      })
      .catch((error) => {
        console.log(error)
      })
    
    API_STATISTIC_ENTRY()
      .then((response) => {
        this.setState({ dataEntryTotal: response.data.data })
      })  
      .catch((error) => {
        console.log(error)
      })
      
    this.setUserDaily()
  }

  changeDateFrom = (e, { value }) => this.setState({ dateFrom: value })

  changeDateTo = (e, { value }) => this.setState({ dateTo: value })

  onClickFilter = (e) => this.setUserDaily()

  render() {
    const { dataCS, dataUser, dateFrom, dateTo } = this.state

    const panes = [
      { menuItem: 'Verificator', render: () => 
        <Tab.Pane attached={false}>
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={8} >
                <h4>Verificator Daily Activity</h4>
                {
                  dataCS.map( (result, i) => {
                    return (
                      <Table singleLine key={i}>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>Tanggal</Table.HeaderCell>
                            <Table.HeaderCell>{result.date}</Table.HeaderCell>
                          </Table.Row>
                          <Table.Row>
                            <Table.HeaderCell>Nama</Table.HeaderCell>
                            <Table.HeaderCell>Hits</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          {
                            result.admins.map( (admin, keyAdmin) => {
                              return (
                                <Table.Row key={keyAdmin}>
                                  <Table.Cell>{admin.fullName}</Table.Cell>
                                  <Table.Cell>{admin.totalProcessed}</Table.Cell>
                                </Table.Row>
                              )
                            })
                          }
                          
                        </Table.Body>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>Total</Table.HeaderCell>
                            <Table.HeaderCell>
                            {
                              result.admins.reduce( (sum, curr) => {
                                return sum + +curr.totalProcessed
                              }, 0)
                            }
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        
                      </Table>
                    )
                  })
                }
              </Grid.Column>
              <Grid.Column width={8} >
                <h4>User Statistics</h4>
                <Grid stackable>
                  <Grid.Row>
                    <Grid.Column width={6} >
                      <span>From</span><br/><br/>
                      <Input fluid type='date' value={dateFrom} onChange={this.changeDateFrom}/>
                    </Grid.Column>
                    <Grid.Column width={6} >
                      <span>To</span><br/><br/>
                      <Input fluid type='date' value={dateTo} onChange={this.changeDateTo}/>
                    </Grid.Column>
                    <Grid.Column width={4} >
                      <br/><br/>
                      <Button fluid primary onClick={this.onClickFilter}>Filter</Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

                <Table singleLine>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Tanggal</Table.HeaderCell>
                      <Table.HeaderCell>Total Apply</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    <Table.Row negative>
                      <Table.Cell>Total</Table.Cell>
                      <Table.Cell>{dataUser.reduce((sum, curr) => sum + + curr.totalApply, 0)}</Table.Cell>
                    </Table.Row>
                    {
                      dataUser.map( (result, i) => {
                        return (
                          <Table.Row key={i}>
                            <Table.Cell>{result.date}</Table.Cell>
                            <Table.Cell>{result.totalApply}</Table.Cell>
                          </Table.Row>
                        )
                      })
                    }
                  </Table.Body>
                </Table>
                
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane> 
      },
    ]

    return (
      <Main>
        
        <Tab menu={{ pointing: true }} panes={panes} />

      </Main>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/app/component/Dashboard/index.js